import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-responsive-md border border-gray" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "First Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Role"),
    /*#__PURE__*/_createElementVNode("th", null, "Relationship"),
    /*#__PURE__*/_createElementVNode("th", null, "Primary Phone"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Emergency Contact"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "CAHPS Survey"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Bereavement Contact"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "table-loading" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_8 = ["colspan"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "No Contacts Found.", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "table-error"
}
const _hoisted_12 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_AuthorizedContactRow = _resolveComponent("AuthorizedContactRow")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    (_ctx.isLoading || _ctx.isError || !_ctx.hasData)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
          _createCommentVNode(" LOADING "),
          (_ctx.isLoading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                return (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                    return (_openBlock(), _createElementBlock("td", null, _hoisted_6))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" EMPTY "),
          (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_10, 8 /* PROPS */, _hoisted_8)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" ERROR "),
          (!_ctx.isLoading && _ctx.isError)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                _createElementVNode("td", { colspan: _ctx.columns }, [
                  _createVNode(_component_ErrorMessageHandler, {
                    title: "Contact list",
                    "try-again": _ctx.getAuthorizedContacts
                  }, null, 8 /* PROPS */, ["try-again"])
                ], 8 /* PROPS */, _hoisted_12)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.contacts, (contact, index) => {
          return (_openBlock(), _createBlock(_component_AuthorizedContactRow, {
            key: contact?.id,
            contact: contact,
            index: index,
            "is-re-order-requested": _ctx.isReOrderRequested,
            "patient-primary-address": _ctx.patientPrimaryAddress,
            columns: _ctx.columns,
            "patient-id": _ctx.patientId,
            "total-contacts": _ctx.totalContacts,
            "cahps-survey-recipient-index": _ctx.cahpsSurveyRecipientIndex,
            "relationships-enum": _ctx.relationshipsEnum,
            "contact-roles-enum": _ctx.contactRolesEnum,
            "cahps-survey-contact-enum": _ctx.cahpsSurveyContactEnum,
            "refresh-list": _ctx.getAuthorizedContacts,
            "move-up": _ctx.moveUp,
            "move-down": _ctx.moveDown,
            "update-contact": _ctx.updateAuthorizedContact,
            "delete-authorized-contact": _ctx.deleteAuthorizedContact
          }, null, 8 /* PROPS */, ["contact", "index", "is-re-order-requested", "patient-primary-address", "columns", "patient-id", "total-contacts", "cahps-survey-recipient-index", "relationships-enum", "contact-roles-enum", "cahps-survey-contact-enum", "refresh-list", "move-up", "move-down", "update-contact", "delete-authorized-contact"]))
        }), 128 /* KEYED_FRAGMENT */))
  ]))
}